import React, { useState, useEffect, useCallback, useRef } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";

// import "../styles/SideBarStyle.css";
import CourseDetailsPage from "../../../features/offerings/pages/CourseDetailPage";

import strings from "../../../utils/Strings";
import ".././.././../utils/FontTheme.css";
import { getCssVariable } from "../../../utils/Colors";
import { ApiProvider } from "../../../service/ApiContext";
import { useDispatch, useSelector } from "react-redux";
import { useApi } from "../../../service/ApiContext";
import { Form, Row, Col } from "react-bootstrap";
import ComingSoonPage from "../../../components/ComingSoonPage";

import quesIcon from "../assets/blueQuesIcon.png";
import Loader, { LocalStorage, UserDeviceStorage } from "../../../utils/Utils";

import Logger from "../../../utils/Logger";
import { RootState } from "../../../store/store";

import hubicon from "../../../assets/images/sidebarImages/hubIcon.png";
import hubselectedicon from "../../../assets/images/sidebarImages/hubselectedIcon.png";
import CommonUtils from "../../../utils/Common_Utils";
import LiveSessionSelectedIcon from "../../../assets/images/sidebarImages/live_session_selected.png";
import LiveUnselected from "../../../assets/images/sidebarImages/live_unselected.png";
import { useAlert } from "../../../components/AlertContextComponent";
import ErrorAlertPopup from "../../../components/AlertErrorPopupComponent";
import AutoLogoutAlertPopup from "../../../components/AutoLogoutCustomAlert";
import OfferingsSelected from "../../../assets/images/sidebarImages/Offering_Select.png";
import OfferingsUnSelected from "../../../assets/images/sidebarImages/Offering_Unselect.png";
import {
  ClipBoardImageDetection,
  NoPrintProtection,
  PreventPrtScrKey,
  PreventSnipTool,
} from "../../../components/PreventScreenshotAndPrint";
import RouteValidator from "../../../service/ApiRoutes";
import InvalidateUrlHandlerpage from "../../../components/InvalidUrlValidatePage";
import SpeedTestComponent from "../../../components/InternetSpeedTest";

import CodeActive from "../../../assets/images/sidebarImages/code active.png";
import CodeInActive from "../../../assets/images/sidebarImages/code inactive.png";
import InterviewUnselected from "../../../assets/images/sidebarImages/InterviewUnselected.png";
import InterviewSelected from "../../../assets/images/sidebarImages/InterviewSelected.png";
import SidebarVersionTwo from "../../../features2/sidebar/components/sidebar";
import Profile from "../../../features/profile/Pages/ProfilePage";
import LiveSessionPage from "../../../features/liveSessions/pages/LiveSessionPage";
import CodeHub from "../../../features/codehub/pages/CodeHub";
import OfferingsMainPage from "../../../features/offerings/pages/OfferingMainPage";
import DashboardMainPage from "../../../features/inventory_dashboard/pages/DashboardMainPage";
import ViewDetailsOverlay from "../../../features2/dashboard/pages/ViewDetailedOverlay";
import ResultOverView from "../../../features/inventory_dashboard/components/ResultOverViewPage";
import AllAssessmentPage from "../../../features/assessment/pages/AllAssessmentCardPage";
import AssessmentInstructions from "../../../features/assessment/pages/InstructionPage";
import VideoLandingPage from "../../../features2/recommendation/vedio-recommendation/pages/VideoLandingPage";
import IndustryVideoLandingPage from "../../../features/recommendation/vedio-recommendation/pages/IndustyVideoLandingPage";
import TextRecommendation from "../../../features/recommendation/textRecommendation/pages/textPage";
import RecommendationJozunaView from "../../../features2/recommendation/recommendationJozunaView/pages/JozunaRecommendationViewPage";
import VideoCypherPlayer from "../../../features2/recommendation/vedio-recommendation/pages/VideoCypherPlayVideoPage";
import CalenderPage from "../../../features/calender/pages/calenderPage";
import SoundListPage from "../../../features/AudioPlayer/components/soundtrack";
import OTPVerification from "../../../features/assessment/pages/AssessmentOTPVerificationPage";
import InterviewFeedbackPage from "../../../features2/interview_hub/pages/InterviewFeedbackPage";
import InterviewHubPage from "../../../features2/interview_hub/pages/InterviewHubPage";
import { setAutoLogoutActive } from "../../../features/recommendation/vedio-recommendation/data/redux/QuizLogoutRedux";
import { ProfileAPiResponse } from "../../../features/profile/data/response/LoginApiResponse";
import ProfileClient from "../../../features/profile/data/api/LoginClient";
import {
  setLiveSessionActiveUrl,
  setProfileKeys,
} from "../../../features/login/data/redux/LoginReducer";
import { LoginRequest } from "../../../features/login/data/request/LoginRequest";
import { LoginResponse } from "../../../features/login/data/response/LoginResponse";
import LoginClient from "../../../features/login/data/api/LoginClient";
import AssessmentListPage from "../../assessment/pages/AssessmentHomePage";
import CameraAudioDeviceCheck from "../../assessment/pages/CameraAudioVideoPage";
import { CameraProvider } from "../../../features2/assessment/components/CameraContext";
import OTPVerificationVersionTwo from "../../assessment/pages/OtpVerificationPage";
import InstructionPage from "../../assessment/pages/InstructionPage";
import DashboardNeedHelp from "../../dashboard/components/DashboardNeedHelp";
import { logActionEvent } from "../../../analytics/analytics_utils";
import analytics_strings from "../../../analytics/analytics_strings";
import RightModal from "../../recommendation/needHelp/pages/NeedHelpPage";
import LearningRoomViewPage from "../../learning_room/pages/LearningRoomViewPage";
import LearningRoomLandingPage from "../../learning_room/pages/LearningRoomLandingPage";
import LiveSessionPageVersionTwo from "../../liveSessions/pages/LiveSessionPage";
import CodeHubVersionTwo from "../../codehub/pages/CodeHub";
import ProgramSchedulePage from "../../calender/pages/calenderPage";
import ProfileVersion from "../../../features/profile/Pages/ProfilePage";
import ProfileVersionTwo from "../../profile/Pages/ProfilePage";
import CertificateGenerator from "../../certficates/pages/CertificatePage";
import { AssessmentProctoringProvider } from "../../assessment_activeproctoring/hooks/ActiveProctoringContext";
import AssessmentProctoringLayer from "../../assessment_activeproctoring/component/ActiveProctoringAssessment";
import VideoPlayerV2Component from "../../learning_room/components/VideoPlayerV2Component";
import RightModalRecommendation from "../../recommendation/needHelp/pages/NeedHelpRecommendation";
import OurServicesPage from "../../ourServices/pages/OurServices";
import GalleryPage from "../../gallery/pages/GalleryPage";
import ChatBotIcon from "../../../features/chatbot/pages/ChatBotIcon";
import RecommendationJozunaViewCoursePage from "../../recommendation/recommendationJozunaView/pages/JozunaRecommendationViewCoursePage ";
import FeedBackViewPage from "../../dashboard/pages/FeedBackViewPage";
import LearningRoomVideoPage from "../../learning_room/components/LearningRoomVideoPage";
import { setPrograms } from "../../calender/data/redux/reducer/ProgramDetailReducer";
import DashboardPage from "../../dashboard/pages/DashboardPage";

const excludedPages = [
  "/",
  "/sign-up",
  "/forgot-password",
  "/dashboard/assessment/instruction/otp",
  "/dashboard/assessment/instruction",
];

const videoInactiveTimer = [
  "/dashboard/recommendation/jozunaview/video",
  "/dashboard/learning-room/view-courses/video",
  "/dashboard/learning-room/view-labsession/video",
];

// const footerLinks: FooterLink[] = [
//   { label: ". About", path: process.env.REACT_APP_ABOUTUS_URL || "" },
//   { label: ". Contact Us", path: process.env.REACT_APP_CONTACTUS_URL || "" },
// ];
interface LiveSession {
  session_url: string | null;
  session_password: string | null;
  registered: boolean;
}

interface LiveSessionData {
  event_id: string;
  program_id: string;
  program_title: string;
  event_type: string;
  event_title: string;
  event_description: string | null;
  event_duration: string;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  live_session: LiveSession;
  registration_deadline?: string | null;
  prerequisites?: string | null;
  learning_outcomes?: string | null;
}

// Retrieve the CSS variable values
const bgColor = getCssVariable("--sideMenu-bgColor");
const textColor = getCssVariable("--sideMenu-textColor");
const selectedTextColor = getCssVariable("--sideMenu-selectedTextColor");
const selectedBgColor = getCssVariable("--sidemenu-selectedbgColor");
const footerTextColor = getCssVariable("--sideMenu-footerTextColor");

const DashboardVersionTwo: React.FC = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .grecaptcha-badge {
        display: none !important;
        position: fixed !important;
        z-index: 9999 !important;
      }
    `;
    document.head.appendChild(style);
  }, []);
  const api = useApi();
  const navigate = useNavigate();
  // const userData = useSelector((state: RootState) => state.profile.profileKeys);

  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0); // State to track active tab
  const [liveActiveTab, setLiveActiveTab] = useState(0);
  const [showTabNavigator, setShowTabNavigator] = useState(false); // State to track visibility of TabNavigator
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const handleTabChange = (index: number) => {
    const routes = ["profile", "settings", "services"];
    setActiveTab(index);
    navigate(`/dashboard/${routes[index]}`); // Show TabNavigator when selecting profile
  };
  const handleLiveTabChange = (index: number) => {
    const LiveChanges = ["Live", "UpComing", "Completed"];
    setActiveTab(index);
  };
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  const { showAlert } = useAlert();
  const { hideAlert } = useAlert();
  const warningTimerRef = useRef<NodeJS.Timeout | null>(null);

  const idleTimerRef = useRef<NodeJS.Timeout | null>(null);
  const isWarningShown = useRef(false);
  const [useShow, setUseShow] = useState(false);

  const userLogout = useCallback(() => {
    // showAlert({ show: false }); // Ensure the popup is hidden immediately on logout
    Logger.info("Logging out due to inactivity...");
    LocalStorage.deleteAllLocalData();
    dispatch(setAutoLogoutActive(false));

    // isWarningShown.current = false;
    navigate("/"); // Redirect to login page
  }, [navigate]);

  const resetIdleTimer = useCallback(
    (freezePopUp: boolean) => {
      if (excludedPages.includes(location.pathname)) {
        return;
      }
      if (!videoInactiveTimer.includes(location.pathname)) {
        if (freezePopUp) {
          if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
          if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
          return;
        }

        if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
        if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

        // Show warning popup after 14 minutes
        warningTimerRef.current = setTimeout(
          () => {
            setUseShow(true);
          },
          14 * 60 * 1000,
        );
        // Auto logout after 15 minutes
        idleTimerRef.current = setTimeout(
          () => {
            setUseShow(false);
            Logger.info("###App inactive, logging out...", useShow);
            userLogout();
            resetIdleTimer(true);
          },
          15 * 60 * 1000,
        );
      } else {
        if (freezePopUp) {
          if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
          if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
          return;
        }

        if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
        if (idleTimerRef.current) clearTimeout(idleTimerRef.current);

        // Show warning popup after 14 minutes
        warningTimerRef.current = setTimeout(
          () => {
            dispatch(setAutoLogoutActive(true));

            setUseShow(true);
          },
          59 * 60 * 1000,
        );
        // Auto logout after 15 minutes
        idleTimerRef.current = setTimeout(
          () => {
            setUseShow(false);
            Logger.info("###App inactive, logging out...", useShow);
            userLogout();
            resetIdleTimer(true);
          },
          60 * 60 * 1000,
        );
      }
    },
    [location.pathname, userLogout],
  );

  const SESSION_TIMEOUT_MINUTES = 55;
  const SESSION_STORAGE_KEY = "sessionTimerData";

  interface TimerData {
    startTime: string; // ISO format timestamp
    endTime: string; // ISO format timestamp
  }

  const emailOrUid = LocalStorage.getLocalData("email_address");
  const password = LocalStorage.getLocalData("entity_password");

  const intervalRef = useRef<NodeJS.Timeout>();
  const sessionTimerRef = useRef<NodeJS.Timeout>();

  const formatTime = (date: Date) => {
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const sessionTimerHandle = useCallback(
    (remainingMinutes: number = SESSION_TIMEOUT_MINUTES) => {
      // Clear existing timers
      if (sessionTimerRef.current) clearTimeout(sessionTimerRef.current);
      if (intervalRef.current) clearInterval(intervalRef.current);

      const now = new Date();
      const endTime = new Date(now.getTime() + remainingMinutes * 60 * 1000);

      // Store as ISO strings
      LocalStorage.setLocalData(
        SESSION_STORAGE_KEY,
        JSON.stringify({
          startTime: now.toISOString(),
          endTime: endTime.toISOString(),
        }),
      );

      Logger.info(`Session Timer: Started at ${formatTime(now)}`);
      Logger.info(`Session Timer: Will expire at ${formatTime(endTime)}`);

      // Update every minute
      intervalRef.current = setInterval(() => {
        const remainingMs = endTime.getTime() - Date.now();
        const remainingMinutes = Math.ceil(remainingMs / (60 * 1000));

        if (remainingMinutes > 0) {
          Logger.info(`Session Timer: ${remainingMinutes} minute(s) remaining`);
        }

        if (remainingMs <= 0) {
          clearInterval(intervalRef.current!);
          LocalStorage.removeLocalData(SESSION_STORAGE_KEY);
        }
      }, 60 * 1000);

      // Set expiration timeout
      sessionTimerRef.current = setTimeout(
        () => {
          clearInterval(intervalRef.current!);
          LocalStorage.removeLocalData(SESSION_STORAGE_KEY);
          Logger.info(`Session Timer: Expired at ${formatTime(new Date())}`);
          userLogin();
        },
        remainingMinutes * 60 * 1000,
      );
    },
    [],
  );

  // Initialize timer on mount
  useEffect(() => {
    const storedTimer = LocalStorage.getLocalData(SESSION_STORAGE_KEY);

    if (storedTimer) {
      const timerData: TimerData = JSON.parse(storedTimer);
      const endTime = new Date(timerData.endTime);
      const remainingMs = endTime.getTime() - Date.now();

      if (remainingMs > 0) {
        const remainingMinutes = remainingMs / (60 * 1000);
        Logger.info(
          `Session Timer: Resuming with ${remainingMinutes.toFixed(
            1,
          )} minutes left`,
        );
        sessionTimerHandle(remainingMinutes);
      } else {
        LocalStorage.removeLocalData(SESSION_STORAGE_KEY);
        sessionTimerHandle();
      }
    } else {
      sessionTimerHandle();
    }

    return () => {
      clearTimeout(sessionTimerRef.current);
      clearInterval(intervalRef.current);
    };
  }, [sessionTimerHandle]);

  const userLogin = async () => {
    Loader.showLoading("");
    api.setAuthToken(null);

    const param: LoginRequest = {
      email_address: emailOrUid!.trim().toLowerCase(), //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
      entity_password: password!,
      entity_type: "USER",
    };

    try {
      const response = await api.post<LoginResponse>(LoginClient.token, param);
      const deviceId_header = response.headers["device-id"];
      if (response.headers["device-id"]) {
        UserDeviceStorage.setDeviceId(
          emailOrUid!.trim().toLowerCase(),
          deviceId_header,
        ); //(12-09-2025) Rana, Vivin, and Prashanth told me to send the email in lowercase.
      }
      if (response.data.access_token) {
        LocalStorage.setLocalData("access_token", response.data.access_token);
        sessionTimerHandle(SESSION_TIMEOUT_MINUTES);
      }
    } catch (error) {
      Logger.error("Login failed", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  useEffect(() => {
    resetIdleTimer(false);

    const resetActivityTimer = () => {
      resetIdleTimer(false);
    };

    window.addEventListener("mousemove", resetActivityTimer);
    window.addEventListener("keydown", resetActivityTimer);

    return () => {
      window.removeEventListener("mousemove", resetActivityTimer);
      window.removeEventListener("keydown", resetActivityTimer);
      resetIdleTimer(true);
    };
  }, [resetIdleTimer, showAlert]);

  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileOpen(!isMobileOpen);
  const shouldShowTabNavigator =
    location.pathname.includes("/dashboard/profile") ||
    location.pathname.includes("/dashboard/settings") ||
    location.pathname.includes("/dashboard/services");
  const [Apptoken, setAppToken] = useState<string | null>(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
    if (!isModalOpen) {
      logActionEvent(
        analytics_strings.analytics_events.reccomendation_needHelp,
        {
          candidate_id: userData.candidate_id,
        },
      );
    }
  };
  const userProfile = async () => {
    Loader.showLoading("Loading...");
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<ProfileAPiResponse>(
        ProfileClient.profileUrl,
      );
      const name = response.data.first_name;
      const institute_id = response.data.institute_id;
      const keys = {
        institute_id: response.data.institute_id,
        first_name: response.data.first_name,
        last_name: response.data.last_name,
        contact_email: response.data.contact_email,
        education: response.data.education,
        course: response.data.course,
        grade: response.data.grade,
        admission_year: response.data.admission_year,
        institute_name: response.data.institute_name,
        roll_number: response.data.roll_number,
        partner_institute: response.data.partner_institute,
        logo_url: response.data.logo_url,
        favicon_url: response.data.favicon_url,
        candidate_id: response.data.candidate_id,
        codehub_enabled: response.data.codehub_enabled,
        interviewhub_enabled: response.data.interviewhub_enabled,
        gallery_enabled: response.data.gallery_enabled,
        email_address: response.data.email_address,
      };
      dispatch(setProfileKeys(keys));
      CommonUtils.setFaviconTitle(
        response.data.favicon_url,
        response.data.institute_name,
      );
      LocalStorage.setLocalData("profileName", name);
      LocalStorage.setLocalData("institute_id", institute_id);
      LocalStorage.setLocalData("roll_number", response.data.roll_number); //to fetch in dashboard score page
      if (
        response &&
        location.state.viaLogin &&
        location.state.viaLogin === true
      ) {
        //only first time via login will do the tab navigation

        //Navigate to dashboard or program hub ,now program hub is first tab
        if (response.data.partner_institute === true) {
          // navigate(strings.routing.programHub);
          navigate(strings.routing.dashboardPage);
        } else {
          navigate(strings.routing.dashboardPage);
        }
      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        Loader.dismissLoading();
      }, 300); // 300ms ensures loader flashes at least
    }
  };
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  useEffect(() => {
    getProgram();
  }, []);
  const getProgram = async () => {
    if (!userData.institute_id) return;
    Loader.showLoading("Loading...");

    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    // const institute_id = LocalStorage.getLocalData("institute_id");
    try {
      const response = await api.get<any>(
        // `/institutes/${institute_id}/program`
        `/eprogram/${userData.institute_id}`,
      );
      Logger.info("respocedata", response.data.programs);
      if (response.data.error) {
        dispatch(setPrograms([]));
        return;
      }
      if (response.data.programs && response.data.programs.length > 0) {
        Logger.info("response data", response.data.programs);
        dispatch(setPrograms(response.data.programs));
        Logger.info("response", response.data);
      } else {
        dispatch(setPrograms([]));
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  // Add a new state for storing the session URL
  const [activeSessionUrl, setActiveSessionUrl] = useState<string | null>(null);
  const [sessions, setSessions] = useState<LiveSessionData[]>([]);

  const fetchLiveSessions = async () => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading();
    try {
      const response = await api.get<{ live_session: LiveSessionData[] }>(
        `/live_session/Active?program_ids=all&notify=${true}&offset_time=${CommonUtils.findOffsetDuration().offset
        }`,
      );
      Logger.info("API Response:", response.data);

      if (response.data && Array.isArray(response.data.live_session)) {
        const sessionsData = response.data.live_session;
        setSessions(sessionsData);

        // Find the first session where session_url is not null AND registered is true
        const activeSession = sessionsData.find(
          (session: LiveSessionData) => session.live_session?.session_url,
        );

        // Set the session URL if found, otherwise clear it
        if (activeSession && activeSession.live_session.session_url) {
          dispatch(
            setLiveSessionActiveUrl(activeSession.live_session.session_url),
          );
          setActiveSessionUrl(activeSession.live_session.session_url);
          Logger.info(
            "Found active session URL:",
            activeSession.live_session.session_url,
          );
        } else {
          dispatch(setLiveSessionActiveUrl(null));
          setActiveSessionUrl(null);
          Logger.info("No active session found with URL and registration");
        }
      } else {
        Logger.error("Expected an array but got:", typeof response.data);
        setSessions([]);
        dispatch(setLiveSessionActiveUrl(null));

        setActiveSessionUrl(null); // Clear URL on error
      }
    } catch (error) {
      Logger.error("Error fetching live sessions:", error);
      setSessions([]);
      dispatch(setLiveSessionActiveUrl(null));

      setActiveSessionUrl(null); // Clear URL on error
    } finally {
      Loader.dismissLoading();
    }
  };
  // useEffect(() => {
  //   getProgram();
  // }, []);
  const query = useQuery();
  useEffect(() => {
    Logger.info("Inside the useEffect for URL changes");

    // Extract token and region from URL query parameters
    const tokenFromURL = query.get("token");
    const regionFromURL = query.get("region");
    const getInstituteID = query.get("institute_id");
    if (getInstituteID) {
      LocalStorage.setLocalData("institute_id", getInstituteID); // Store token in local storage
    }

    Logger.info(
      "Query string:",
      query,
      "Token from URL:",
      tokenFromURL,
      "Region from URL:",
      regionFromURL,
      "Window location search:",
      window.location.search,
    );

    // Handling token
    if (tokenFromURL) {
      Logger.info("Token successfully retrieved from URL:", tokenFromURL);
      LocalStorage.setLocalData("access_token", tokenFromURL); // Store token in local storage
      setShowSidebar(false);
    } else {
      Logger.info("No token found in URL. Using appToken:");
      setShowSidebar(true);
      const storedToken = LocalStorage.getLocalData("access_token");
      Logger.info(
        "No token found in URL. Using appToken**************:",
        storedToken,
      );

      if (storedToken) {
        setAppToken(storedToken); // Use the token from local storage if not found in URL
        LocalStorage.setLocalData("access_token", storedToken);
      }
    }

    // Handling region
    if (regionFromURL) {
      Logger.info("Region successfully retrieved from URL:", regionFromURL);
      LocalStorage.setLocalData("region", regionFromURL); // Store region in local storage
    } else {
      Logger.info("No region found in URL.");
    }
    userProfile();
    fetchLiveSessions();
    // getProgram();

    setLoading(false);
  }, []);

  if (loading) {
    return <div className="landing-page"></div>;
  }

  return (
    <ApiProvider>
      <CameraProvider>
        <SidebarVersionTwo
          isMobileOpen={isMobileOpen}
          toggleMobileMenu={toggleMobileMenu}
          logoUrl={profileData.logo_url}
        >
          <Row style={{ overflow: "hidden" }}>
            <Col
              lg={showSidebar === true ? 12 : 12}
              md={showSidebar ? 12 : 12}
              xs={showSidebar ? 12 : 12}
              style={{
                padding: "0px 10px 0px 10px",
                backgroundColor: "white",
                // Bottom box shadow
              }}
            >
              <main className="flex-grow-1 p-6">
                {location.pathname ===
                  "/dashboard/recommendation/jozunaview" && (
                    <div
                      // className="drop flex-grow-1 p-2"
                      // style={{
                      //   display: "flex",
                      //   alignItems: "center",
                      //   justifyContent: "space-between",
                      //   backgroundColor: "white",
                      //   boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
                      //   minHeight: "10vh",
                      //   zIndex: "10000",
                      //   // borderBottom: "2px solid rgba(0,0,0,0.08)",
                      // }}
                      style={{
                        display: "flex",
                        alignItems: "start",
                        justifyContent: "space-between",
                        boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
                        padding: "20px",
                        paddingRight: "0px",
                        paddingLeft: "0px",
                        height: "12vh",
                        zIndex: 10000,
                        marginBottom: "10px",
                      }}
                    >
                      <div>
                        {" "}
                        <div
                          style={{
                            color: "#121212",
                            marginLeft: "20px",
                            fontFamily: "Mazzard",
                            fontSize: "20px",
                            // marginRight: "20px", // Adjust margin to provide space after the welcome message
                          }}
                        >
                          Recommendations
                        </div>
                        <div
                          style={{
                            color: "#1A1E2C",
                            marginLeft: "20px",
                            fontFamily: "Mazzard",
                            fontSize: "14px",
                            fontWeight: "300",
                            // marginRight: "20px", // Adjust margin to provide space after the welcome message
                          }}
                        >
                          Let's make today count. Here is your learning
                          progress.{" "}
                        </div>
                      </div>
                      <img
                        src={quesIcon} // put your image path here
                        alt="Recommendations"
                        style={{
                          width: "40px",
                          height: "40px", // adjust size as needed
                          marginRight: "25px",
                          cursor: "pointer",
                        }}
                        onClick={toggleModal}
                      />

                      {/* UserDropdown component */}
                    </div>
                  )}
                {location.pathname === "/dashboard/programSchedule" && (
                  <div
                    // className="drop flex-grow-1 p-2"
                    style={{
                      display: "flex",
                      alignItems: "start",
                      justifyContent: "space-between",
                      boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
                      padding: "20px",
                      paddingRight: "0px",
                      paddingLeft: "0px",
                      height: "12vh",

                      zIndex: 10000,
                      marginBottom: "10px",
                    }}
                  >
                    <div>
                      {" "}
                      <div
                        style={{
                          color: "#121212",
                          marginLeft: "20px",
                          fontFamily: "Mazzard",
                          fontSize: "20px",
                          // marginRight: "20px", // Adjust margin to provide space after the welcome message
                        }}
                      >
                        Learning Schedule{" "}
                      </div>
                      <div
                        style={{
                          color: "#1A1E2C",
                          marginLeft: "20px",
                          fontFamily: "Mazzard",
                          fontSize: "14px",
                          fontWeight: "300",
                          // marginRight: "20px", // Adjust margin to provide space after the welcome message
                        }}
                      >
                        Let's make today count. Here is your learning
                        progress.{" "}
                      </div>
                    </div>
                    <img
                      src={quesIcon} // put your image path here
                      alt="Recommendations"
                      style={{
                        width: "40px",
                        height: "40px", // adjust size as needed
                        marginRight: "25px",
                        cursor: "pointer",
                      }}
                      onClick={toggleModal}
                    />

                    {/* UserDropdown component */}
                  </div>
                )}

                {location.pathname === "/dashboard/interview-hub" && (
                  <div
                    // className="drop flex-grow-1 p-2"
                    // style={{
                    //   display: "flex",
                    //   alignItems: "center",
                    //   justifyContent: "space-between",
                    //   backgroundColor: "white",
                    //   boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
                    //   minHeight: "10vh",
                    //   zIndex: "10000",
                    // }}
                    style={{
                      display: "flex",
                      alignItems: "start",
                      justifyContent: "space-between",
                      boxShadow: "0 4px 8px rgba(105, 103, 103, 0.1)", // Bottom box shadow
                      padding: "20px",
                      paddingRight: "0px",
                      paddingLeft: "0px",
                      height: "12vh",

                      zIndex: 10000,
                      marginBottom: "10px",
                    }}
                  >
                    <div>
                      {" "}
                      <div
                        style={{
                          color: "#121212",
                          marginLeft: "20px",
                          fontFamily: "Mazzard",
                          fontSize: "20px",
                          marginRight: "20px", // Adjust margin to provide space after the welcome message
                        }}
                      >
                        InterviewIQ{" "}
                      </div>
                      <div
                        style={{
                          color: "#1A1E2C",
                          marginLeft: "20px",
                          fontFamily: "Mazzard",
                          fontSize: "14px",
                          fontWeight: "300",
                          marginRight: "20px", // Adjust margin to provide space after the welcome message
                        }}
                      >
                        Hey There! Let's Practice Smarter with Verified
                        Interview Simulations{" "}
                      </div>
                    </div>
                    <img
                      src={quesIcon} // put your image path here
                      alt="Recommendations"
                      style={{
                        width: "40px",
                        height: "40px", // adjust size as needed
                        marginRight: "25px",
                        cursor: "pointer",
                      }}
                      onClick={toggleModal}
                    />

                    {/* UserDropdown component */}
                  </div>
                )}
                <ApiProvider>
                  {/* {shouldShowTabNavigator && (
                    <>
                      <TabNavigator
                        activeTab={activeTab}
                        onTabChange={handleTabChange}
                      />
                    </>
                  )} */}
                  <RouteValidator />
                  <AssessmentProctoringProvider>
                    <AssessmentProctoringLayer />
                    <Routes>
                      {/* <Route path="*" element={<InvalidateUrlHandlerpage />} /> */}
                      <Route
                        path="*"
                        element={
                          window.location.pathname !== "/dashboard/" ? (
                            <InvalidateUrlHandlerpage />
                          ) : null
                        }
                      />
                      <Route path="/profile" element={<ProfileVersionTwo />} />
                      <Route path="settings" element={<ComingSoonPage />} />
                      <Route path="services" element={<ComingSoonPage />} />
                      <Route
                        path="livesession"
                        element={<LiveSessionPageVersionTwo />}
                      />
                      <Route path="codehub" element={<CodeHubVersionTwo />} />
                      {/* <Route path="livesession" element={<LiveSessionPage />} /> */}
                      <Route
                        path="/our-services"
                        element={<OurServicesPage />}
                      />
                      <Route
                        path="/offerings/techbotsacademy"
                        element={<OfferingsMainPage />}
                      />
                      <Route
                        path="/offerings/techbotsacademy/courseDetail"
                        element={<CourseDetailsPage />}
                      />
                      <Route path="student" element={<DashboardPage />} />
                      <Route
                        path="speedtest"
                        element={<SpeedTestComponent />}
                      />
                      {/* <Route
                    path="inventorydashboard"
                    element={<DashboardMainPage />}
                  /> */}
                      <Route
                        path="certificates"
                        element={<CertificateGenerator />}
                      />
                      <Route
                        path="student/skills-details"
                        element={<ViewDetailsOverlay />}
                      />
                      <Route
                        path="/student/skills-details/result_overview"
                        element={<ResultOverView />}
                      />
                      {/* <Route
                      <Route
                        path="student/skills-details"
                        element={<ViewDetailsOverlay />}
                      />
                      <Route
                        path="/student/skills-details/result_overview"
                        element={<ResultOverView />}
                      />
                      {/* <Route
                    path="inventorylinechartdashboard"
                    element={<LineChartComponent />}
                  /> */}
                      <Route
                        path="assessment"
                        element={<AssessmentListPage />}
                      />
                      {/* <Route
                      path="assessment/allAssessment"
                      element={<AllAssessmentPage />}
                    /> */}
                      {/* <Route
                      path="assessment/allAssessment/instruction"
                      element={<AssessmentInstructions />}
                    /> */}
                      <Route
                        path="assessment/cameracheck"
                        element={<CameraAudioDeviceCheck />}
                      />
                      <Route
                        path="assessment/instruction"
                        element={<InstructionPage />}
                      />
                      <Route
                        path="recommendation"
                        element={<VideoLandingPage activeTb={0} />}
                      />
                      <Route
                        path="learning-room"
                        element={<LearningRoomLandingPage activeTb={1} />}
                      />
                      <Route
                        path="text-recommendation"
                        element={<TextRecommendation />}
                      />
                      <Route
                        path="assessment/student"
                        element={<ComingSoonPage />}
                      />
                      <Route
                        path="recommendation/jozunaview"
                        element={<RecommendationJozunaView activeTb={0} />}
                      />
                      <Route
                        path="learning-room/view-courses"
                        element={<LearningRoomViewPage />}
                      />
                      <Route
                        path="recommendation/jozunaview/course"
                        element={
                          <RecommendationJozunaViewCoursePage activeTb={0} />
                        }
                      />
                      {/* <Route
                      path="learning-room/view-courses"
                      element={<LearningRoomViewPage />}
                    /> */}
                      <Route
                        path="learning-room/view-courses/video"
                        element={<LearningRoomVideoPage />}
                      />
                      <Route
                        path="recommendation/jozunaview/video"
                        element={<VideoPlayerV2Component />}
                      />
                      <Route
                        path="learning-room/view-labsession/video"
                        element={<LearningRoomVideoPage />}
                      />
                      <Route
                        path="programSchedule"
                        element={<ProgramSchedulePage />}
                      />
                      <Route path="ourservices" element={<OurServicesPage />} />
                      <Route
                        path="/assessment/cameracheck/otp"
                        element={<OTPVerificationVersionTwo />}
                      />
                      <Route path="audio" element={<SoundListPage />} />
                      <Route
                        path="interview-hub/feedback"
                        element={<InterviewFeedbackPage />}
                      />
                      <Route
                        path="interview-hub/chat"
                        element={<InterviewHubPage />}
                      />
                      <Route path="gallery" element={<GalleryPage />} />
                      <Route
                        path="interview-hub"
                        element={<InterviewHubPage />}
                      />
                      <Route
                        path="student/feedback"
                        element={<FeedBackViewPage />}
                      />
                    </Routes>
                  </AssessmentProctoringProvider>

                  {useShow && (
                    <AutoLogoutAlertPopup
                      body="We have not detected any user activity for a while. Do you want to logout?"
                      btn1Pressed={() => {
                        userLogout();
                        resetIdleTimer(true);
                      }}
                      btn2Pressed={() => {
                        resetIdleTimer(false);
                        setUseShow(false);
                        dispatch(setAutoLogoutActive(false));
                      }}
                    />
                  )}
                </ApiProvider>
              </main>
            </Col>
          </Row>

          <RightModalRecommendation
            isOpen={isModalOpen}
            toggleModal={toggleModal}
          />
        </SidebarVersionTwo>
      </CameraProvider>
    </ApiProvider>
  );
};

export default DashboardVersionTwo;
